// 导出教材激活码
export const exportTextBookXLS = async (context, job, index = 0) => {
  let firtstIndex = index + 1
  const data = context.$store.state.job.export.find(item => item.job_id == job.job_id)
  if (data?.stop || (data?.stop === undefined && firtstIndex > 1)) return
  const { progress, createdAt, failedJobs } = await context.$api.resource.batch(job.batch_id)
  const newJob = { ...job, progress: progress, created_at: createdAt, failedJobs }
  if (firtstIndex == 1) context.$store.commit('setJobQueueExport', newJob)
  if (progress == 100) {
    const data = await context.$api3.user.httpGet(`textbook-license-export/${newJob.job_id}`)
    let sucessJob = { ...newJob, url: data?.full_url?.url }
    context.$store.commit('setJobQueueExport', sucessJob)
  } else {
    context.$store.commit('setJobQueueExport', newJob)
    if (failedJobs >= 1) return
    await new Promise(resolve => setTimeout(resolve, 1000))
    await exportTextBookXLS(context, newJob, firtstIndex)
  }
}

// 导出权益列表XLS
export const exporEquitytXLS = async (context, job, index = 0) => {
  let firtstIndex = index + 1
  const data = context.$store.state.job.export.find(item => item.job_id == job.job_id)
  if (data?.stop || (data?.stop === undefined && firtstIndex > 1)) return

  const progress = (job?.progress >= 100 || job?.progress + 20 >= 100) ? 99 : (job?.progress || 0) + 20

  const { created_at, state, file_path } = await context.$api3.user.httpGet(`${job.msgType}/${job.job_id}`)

  const failedJobs = state === 3 ? 1 : 0

  const newJob = { ...job, progress: progress, created_at: created_at, failedJobs }
  if (firtstIndex == 1) context.$store.commit('setJobQueueExport', newJob)
  if (state === 2) {
    let sucessJob = { ...newJob, progress: 100, url: file_path?.url }
    context.$store.commit('setJobQueueExport', sucessJob)
  } else {
    context.$store.commit('setJobQueueExport', newJob)
    if (state == 3) return
    await new Promise(resolve => setTimeout(resolve, 1000))
    await exporEquitytXLS(context, newJob, firtstIndex)
  }
}

// 导出MDF
export const exportMDF = async (context, job, index = 0) => {
  let firtstIndex = index + 1
  const data = context.$store.state.job.export.find(item => item.job_id == job.job_id)
  if (data?.stop || (data?.stop === undefined && firtstIndex > 1)) return
  const { progress, createdAt, failedJobs } = await context.$api.resource.batch(job.batch_id)
  const newJob = { ...job, progress: progress, created_at: createdAt, failedJobs }
  if (firtstIndex == 1) context.$store.commit('setJobQueueExport', newJob)
  if (progress == 100) {
    const data = await context.$api.resource.exportsTextbookAsyncResult(newJob.job_id)
    let sucessJob = { ...newJob, url: data?.full_url?.url }
    context.$store.commit('setJobQueueExport', sucessJob)
  } else {
    context.$store.commit('setJobQueueExport', newJob)
    if (failedJobs >= 1) return
    await new Promise(resolve => setTimeout(resolve, 1000))
    await exportMDF(context, newJob, firtstIndex)
  }
}

// XLS导出（前端虚假进度条，很快其实没必要）
export const exportXLS = async (context, job, index = 0) => {
  let firtstIndex = index + 1
  const data = context.$store.state.job.export.find(item => item.job_id == job.job_id)
  if (data?.stop || data?.status == 'completed') return
  const progress = job.progress >= 100 ? 100 : job.progress + 2
  const newJob = { ...job, progress: progress }
  context.$store.commit('setJobQueueExport', newJob)
  if (firtstIndex == 1) {
    context.$api3.user.httpPost(`exports/${job.msgType}`, newJob.prop).then(({ file_path }) => {
      let sucessJob = { ...newJob, url: file_path?.url, progress: 100, failedJobs: 0 }
      context.$store.commit('setJobQueueExport', sucessJob)
    }).catch(err => {
      let newJob = { ...job, progress: 100, failedJobs: 1}
      context.$store.commit('setJobQueueExport', newJob)
    })
  }
  await new Promise(resolve => setTimeout(resolve, 500))
  exportXLS(context, newJob, firtstIndex)
}

/**
 * @typedef {Object} JobObject
 * @property {number} created_at - 时间戳
 * @property {number} progress - 进度
 * @property {string} name - 名称
 * @property {string} type - 作业类型，如 'XLS'
 * @property {boolean} stop - 标识是否停止
 */

/**
 * 接口整改| 此函数废弃
 * XLS导出（教材激活码特殊处理）|| 后续xls导出都可以调用此方法
 * @param {*} context - 上下文，一般可视具体情况而定
 * @param {{ url: string, params: object }} http - HTTP 对象，例如封装好的请求函数或 axios 实例
 * @param {JobObject} job - 任务信息对象
**/
export const exportSpecialXLS = async (context, http, job) => {
  const data = context.$store.state.job.export.find(item => item.job_id == job.job_id)
  if (data?.stop) return
  let newJob, number = job.progress
  const updateProgress = () => {
    number = Math.min(number + (Math.floor(Math.random() * 10) + 1), 99)
    context.$store.commit('setJobQueueExport', { ...job, progress: Number(number) })
  }
  const saveTime = setInterval(() => {
    updateProgress()
  }, 1500)
  try {
    updateProgress()
    const { url } = await context.$api3.user.httpPost(http.url, http.params)
    newJob = { ...job, progress: 100, url }
  } catch(err) {
    newJob = { ...job, progress: 100 }
  } finally {
    clearInterval(saveTime)
    context.$store.commit('setJobQueueExport', newJob)
  }
}
// 导入MDF
export const importMDF = async (context, job, index = 0) => {
  let firtstIndex = index + 1
  if (firtstIndex == 1) context.$store.commit('setJobQueueImport', job)
  try {
    const { progress, status } = await context.$api.import_account.getProgress(job.job_id) // 获取导入进度百分比
    let newJob = { ...job, progress, status }
    context.$store.commit('setJobQueueImport', newJob)
    if (progress != 100 && status != 3) {
      await new Promise(resolve => setTimeout(resolve, 1000))
      importMDF(context, newJob, firtstIndex)
    }
  } catch(err) {
    let newJob = { ...job, progress: 100, status: 3 }
    context.$store.commit('setJobQueueImport', newJob)
  }
}

// XLS导入
export const importXLS = async (context, job, index = 0) => {
  let firtstIndex = index + 1
  if (firtstIndex == 1) context.$store.commit('setJobQueueImport', job)
  const { progress, status, created_at } = await context.$api.import_account.getProgress(job.job_id)
  let newJob = { ...job, progress, status, created_at }
  context.$store.commit('setJobQueueImport', newJob)
  if (progress != 100 && status != 3) {
    await new Promise(resolve => setTimeout(resolve, 1000))
    importXLS(context, newJob, firtstIndex)
  }
}


export const initJob = async (context) => {
  const job = window.localStorage.getItem(`job_${context.$store.state.user.userInfo.id}`)
  if (job) {
    context.$store.state.job = JSON.parse(job)
    context.$store.state.job.isShowTip = false // 刷新提示语句不展示
    // 每次刷新页面重置一下任务列表数量，接口崩溃导致前端数据错乱
    let exportArray = context.$store.state.job.export.filter(item => item.status == 'progress')
    let importArray = context.$store.state.job.import.filter(item => item.status == 'progress')
    let total = [...exportArray, ...importArray].length
    context.$store.state.job.num = total
    context.$store.state.job.isDot = total == 0 ? false : true // 每次刷新页面有任务时才自动展开
    context.$store.state.job.export.forEach(async (item) => {
      if ((item.status == 'progress' || !item.url) && item.type === 'MDF') {
        exportMDF(context, item)
        await new Promise(resolve => setTimeout(resolve, 100))
        context.$notify({
          title: '消息',
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: `检测到您有 <i style="color:red">${item.name}</i> 任务未完成，正在为您继续，可在任务列表中查看进度`
        });
      }
      if ((item.status == 'progress' || !item.url) && item.type === 'XLS' && item.axios) {
        // exportSpecialXLS(context, item.axios, item)
        exportTextBookXLS(context, item.axios, item)
        await new Promise(resolve => setTimeout(resolve, 100))
        context.$notify({
          title: '消息',
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: `检测到您有 <i style="color:red">${item.name}</i> 任务未完成，正在为您继续，可在任务列表中查看进度`
        });
      }
    })
    context.$store.state.job.import.forEach(async (item) => {
      if (item.status == 'progress' && item.type === 'XLS') {
        importXLS(context, item)
        await new Promise(resolve => setTimeout(resolve, 100))
        context.$notify({
          title: '消息',
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: `检测到您有 <i style="color:red">${item.name}</i> 任务未完成，正在为您继续，可在任务列表中查看进度`
        });
      }
      if (item.status == 'progress' && item.type === 'PPT') {
        importMDF(context, item)
        await new Promise(resolve => setTimeout(resolve, 100))
        context.$notify({
          title: '消息',
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: `检测到您有 <i style="color:red">${item.name}</i> 任务未完成，正在为您继续，可在任务列表中查看进度`
        });
      }
    })
  }
}
